import { TabPanel, TabView } from "primereact/tabview";
import { DashboardEditorProps } from "components/ComponentTypeTypes";
import React, { FC, useState } from "react";
import { T } from "services/lang/LanguageService";
import { DatasetStatusIndicatorProps } from "../DatasetStatusIndicatorTypes";
import HilightsEditor from "./HilightsEditor";
import GeneralPropertiesEditor from "./GeneralPropertiesEditor";

const DatasetStatusIndicatorEditor: FC<DashboardEditorProps<DatasetStatusIndicatorProps>> = ({
  config,
  onConfigChange,
}) => {
  const [currentConfig, setCurrentConfig] = useState<DatasetStatusIndicatorProps>(config ?? {});
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
    <TabView activeIndex={activeTabIndex} onTabChange={e => setActiveTabIndex(e.index)}>
      <TabPanel header={T("word.general")}>
        <GeneralPropertiesEditor
          currentConfig={currentConfig}
          setCurrentConfig={setCurrentConfig}
          onConfigChange={onConfigChange}
        />
      </TabPanel>
      <TabPanel header={T("word.highlights")}>
        <HilightsEditor
          currentConfig={currentConfig}
          setCurrentConfig={setCurrentConfig}
          onConfigChange={onConfigChange}
        />
      </TabPanel>
    </TabView>
  );
};

export default DatasetStatusIndicatorEditor;
